import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';
import AdminLayout from '../../components/AdminLayout';
import StatCards from '../../components/StatCards';
import { getAllCustomers, getAllOrders, deleteCustomer, blockCustomer, unblockCustomer, IMAGE_BASE_URL } from '../../services/api';
import ExcelJS from 'exceljs';

const ITEMS_PER_PAGE = 10;

// â”€â”€ Pagination button style â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const pgBtn = (disabled, active) => ({
  minWidth: 34, height: 34, padding: '0 10px', borderRadius: 8,
  border: active ? '1px solid #0f766e' : '1px solid #cbd5e1',
  background: active ? '#14b8a6' : disabled ? '#f1f5f9' : '#ffffff',
  color: active ? '#ffffff' : '#0b1f3a',
  cursor: disabled ? 'not-allowed' : 'pointer',
  fontSize: 13, fontWeight: active ? 700 : 500,
  fontFamily: "'Sora','Outfit',sans-serif", transition: 'all .15s',
  opacity: disabled ? 0.35 : 1,
});

const Pagination = function (props) {
  var currentPage = props.currentPage;
  var totalPages = props.totalPages;
  var onPageChange = props.onPageChange;
  var totalItems = props.totalItems;

  var startItem = (currentPage - 1) * ITEMS_PER_PAGE + 1;
  var endItem = Math.min(currentPage * ITEMS_PER_PAGE, totalItems);

  var getPageNumbers = function () {
    var pages = [];
    var maxVisible = 5;
    var start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    var end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
    for (var i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  return (
    React.createElement('div', {
      style: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '16px 4px 8px', borderTop: '1px solid #e2e8f0',
        marginTop: 12, flexWrap: 'wrap', gap: 10, color: '#64748b',
      }
    },
      React.createElement('span', { style: { fontSize: 12, color: '#64748b', fontWeight: 600 } },
        'Showing ' + startItem + '-' + endItem + ' of ' + totalItems + ' customers'
      ),
      React.createElement('div', { style: { display: 'flex', gap: 6, alignItems: 'center' } },
        React.createElement('button', { onClick: function () { onPageChange(1); }, disabled: currentPage === 1, style: pgBtn(currentPage === 1) }, 'First'),
        React.createElement('button', { onClick: function () { onPageChange(currentPage - 1); }, disabled: currentPage === 1, style: pgBtn(currentPage === 1) }, 'Previous'),
        getPageNumbers().map(function (p) {
          return React.createElement('button', { key: p, onClick: function () { onPageChange(p); }, style: pgBtn(false, p === currentPage) }, p);
        }),
        React.createElement('button', { onClick: function () { onPageChange(currentPage + 1); }, disabled: currentPage === totalPages, style: pgBtn(currentPage === totalPages) }, 'Next'),
        React.createElement('button', { onClick: function () { onPageChange(totalPages); }, disabled: currentPage === totalPages, style: pgBtn(currentPage === totalPages) }, 'Last')
      )
    )
  );
};

var avatarColors = [
  'linear-gradient(135deg,#ec4899,#f472b6)',
  'linear-gradient(135deg,#a855f7,#c084fc)',
  'linear-gradient(135deg,#fb7185,#f43f5e)',
  'linear-gradient(135deg,#fbbf24,#f59e0b)',
  'linear-gradient(135deg,#f472b6,#7c3aed)',
  'linear-gradient(135deg,#f87171,#ef4444)',
];

var getInitials = function (name) {
  if (!name) return 'UN';
  return name.split(' ').map(function (w) { return w[0]; }).join('').substring(0, 2).toUpperCase();
};

var IconView = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
    React.createElement('circle', { cx: '12', cy: '12', r: '3' })
  );
};

var IconTrash = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M3 6h18' }),
    React.createElement('path', { d: 'M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' }),
    React.createElement('path', { d: 'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6' }),
    React.createElement('path', { d: 'M10 11v6' }),
    React.createElement('path', { d: 'M14 11v6' })
  );
};

// â”€â”€ Resolve customer ID from order (handles populated or plain string) â”€â”€â”€â”€â”€â”€â”€â”€
var IconDownload = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }),
    React.createElement('path', { d: 'M7 10l5 5 5-5' }),
    React.createElement('path', { d: 'M12 15V3' })
  );
};


var IconCalendar = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M8 2v4' }),
    React.createElement('path', { d: 'M16 2v4' }),
    React.createElement('rect', { x: '3', y: '4', width: '18', height: '18', rx: '2' }),
    React.createElement('path', { d: 'M3 10h18' })
  );
};

var IconChevronDown = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '13', height: '13', fill: 'none', stroke: 'currentColor', strokeWidth: '2.4', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M6 9l6 6 6-6' })
  );
};

var IconClose = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2.4', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M18 6L6 18' }),
    React.createElement('path', { d: 'M6 6l12 12' })
  );
};

var IconMoreVertical = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '16', height: '16', fill: 'none', stroke: 'currentColor', strokeWidth: '2.4', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('circle', { cx: '12', cy: '12', r: '1' }),
    React.createElement('circle', { cx: '12', cy: '5', r: '1' }),
    React.createElement('circle', { cx: '12', cy: '19', r: '1' })
  );
};

var IconUser = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '16', height: '16', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }),
    React.createElement('circle', { cx: '12', cy: '7', r: '4' })
  );
};

var INR = '\u20B9';
var EMPTY_TEXT = '-';

var isPhoneLike = function (value) {
  var text = String(value || '').trim();
  return /^\+?[\d\s()-]{6,}$/.test(text) && /\d/.test(text);
};

var getCustomerDisplayName = function (c) {
  var first = c.firstName || c.first_name || c.firstname || '';
  var last = c.lastName || c.last_name || c.lastname || '';
  var combined = (first || last) ? (String(first) + ' ' + String(last)).trim() : '';
  var candidates = [
    c.name,
    c.fullName,
    c.full_name,
    c.customerName,
    c.customer_name,
    c.userName,
    c.username,
    c.displayName,
    c.display_name,
    combined
  ];
  for (var i = 0; i < candidates.length; i++) {
    var name = String(candidates[i] || '').trim();
    if (name && !isPhoneLike(name)) return name;
  }
  return 'Customer';
};
var resolveOrderCustomerId = function (order) {
  if (!order) return null;
  var id = null;
  if (order.customerId && typeof order.customerId === 'object') id = order.customerId._id || order.customerId.id || null;
  if (!id && order.customer_id && typeof order.customer_id === 'object') id = order.customer_id._id || order.customer_id.id || null;
  if (!id && order.user && typeof order.user === 'object') id = order.user._id || order.user.id || null;
  if (!id && order.userId && typeof order.userId === 'object')     id = order.userId._id || order.userId.id || null;
  if (!id && order.user_id && typeof order.user_id === 'object') id = order.user_id._id || order.user_id.id || null;
  if (!id && order.customer && typeof order.customer === 'object') id = order.customer._id || order.customer.id || null;
  if (!id && typeof order.customerId === 'string') id = order.customerId;
  if (!id && typeof order.customer_id === 'string') id = order.customer_id;
  if (!id && typeof order.user     === 'string') id = order.user;
  if (!id && typeof order.userId   === 'string') id = order.userId;
  if (!id && typeof order.user_id   === 'string') id = order.user_id;
  if (!id && typeof order.customer === 'string') id = order.customer;
  return id != null ? String(id) : null;
};

var getCustomerId = function (customer) {
  if (!customer) return null;
  return customer._id || customer.id || null;
};

var getOrderStatus = function (order) {
  if (!order) return '';
  return String(order.orderStatus || order.status || order.order_status || '').toLowerCase().trim();
};

var getOrderTotal = function (order) {
  if (!order) return 0;
  return Number(order.finalAmount || order.payableAmount || order.totalPayable || order.totalAmount || order.total || order.amount || order.orderTotal || order.grandTotal || 0) || 0;
};

var getOrderItems = function (order) {
  return order && (order.products || order.items || order.orderItems || order.order_items) || [];
};

var getOrderCouponCode = function (order) {
  if (!order) return '';
  var coupon = order.coupon || order.appliedCoupon || order.couponDetails;
  if (typeof coupon === 'string') return coupon;
  return order.couponCode || order.coupon_code || (coupon && (coupon.couponCode || coupon.code)) || '';
};

var getOrderCouponMeta = function (order) {
  var coupon = order && (order.coupon || order.appliedCoupon || order.couponDetails);
  coupon = coupon && typeof coupon === 'object' ? coupon : {};
  return {
    type: order && (order.couponDiscountType || order.discountType) || coupon.discountType || coupon.type,
    value: order && (order.couponDiscountValue || order.discountValue || order.discountPercentage) || coupon.discountValue || coupon.value || coupon.discount || coupon.percentage,
  };
};

var getOrderDiscount = function (order) {
  if (!order) return 0;
  var coupon = order.coupon || order.appliedCoupon || order.couponDetails;
  var direct = order.couponDiscount !== undefined ? order.couponDiscount
    : (order.couponDiscountAmount !== undefined ? order.couponDiscountAmount : undefined);
  var nested = coupon && typeof coupon === 'object'
    ? (coupon.discountAmount !== undefined ? coupon.discountAmount : (coupon.couponDiscount !== undefined ? coupon.couponDiscount : coupon.amount))
    : undefined;
  return Number(direct !== undefined ? direct : (nested !== undefined ? nested : 0)) || 0;
};

var getOrderCouponDiscountValue = function (order) {
  var coupon = order && (order.coupon || order.appliedCoupon || order.couponDetails);
  var direct = getOrderField(order, ['couponDiscount', 'couponDiscountAmount', 'discountAmount']);
  if (direct !== undefined) return direct;
  return coupon && typeof coupon === 'object' ? getOrderField(coupon, ['discountAmount', 'couponDiscount', 'amount']) : undefined;
};

var getProductData = function (item) {
  var product = item && (item.product || item.productId || item.productDetails || item.product_info || item.product_data);
  return product && typeof product === 'object' ? product : {};
};

var getOrderSubtotal = function (order) {
  return getOrderItems(order).reduce(function (sum, item) {
    var product = getProductData(item);
    var price = Number(product.price !== undefined ? product.price : (item.price !== undefined ? item.price : (item.unitPrice !== undefined ? item.unitPrice : (item.totalPrice !== undefined ? item.totalPrice : item.total)))) || 0;
    var quantity = Number(item.quantity !== undefined ? item.quantity : (item.qty || 1)) || 1;
    return sum + price * quantity;
  }, 0);
};

var getProductImage = function (item) {
  var product = getProductData(item);
  var images = product.images || product.photos || product.pictures || item.images || item.photos || item.pictures;
  var value = product.image || product.imageUrl || product.image_url || product.imageURL || product.imagePath || product.photo || product.picture || (Array.isArray(images) && images[0]) || product.thumbnail || item.image || item.imageUrl || item.image_url || item.imageURL || item.thumbnail || item.productImage || '';
  if (typeof value === 'string' && (value.trim().startsWith('[') || value.trim().startsWith('{'))) {
    try { value = JSON.parse(value); value = Array.isArray(value) ? value[0] : value; } catch (e) { value = ''; }
  }
  if (value && typeof value === 'object') value = value.url || value.src || value.path || value.image || value.imageUrl || value.filename || '';
  if (typeof value !== 'string' || !value.trim()) return '';
  value = value.trim().replace(/\\/g, '/');
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  return String(IMAGE_BASE_URL || '').replace(/\/+$/, '') + '/' + value.replace(/^\/+/, '').replace(/^api\//, '');
};

var getProductVariant = function (item) {
  var product = getProductData(item);
  return product.variant || product.size || item.variant || item.size || item.productVariant || item.productSize || '';
};

var getOrderField = function (order, keys) {
  for (var i = 0; i < keys.length; i++) {
    var value = order && order[keys[i]];
    if (value !== undefined && value !== null && String(value).trim()) return value;
  }
  return undefined;
};

var getSuperCoinDetails = function (order) {
  var nested = order && order.superCoins && typeof order.superCoins === 'object' ? order.superCoins : {};
  return {
    used: getOrderField(order, ['superCoinsUsed', 'superCoinUsed', 'coinsUsed']) !== undefined ? getOrderField(order, ['superCoinsUsed', 'superCoinUsed', 'coinsUsed']) : getOrderField(nested, ['used', 'coins', 'count']),
    amount: getOrderField(order, ['superCoinsDiscount', 'superCoinsAmount', 'superCoinDiscount', 'superCoinAmount', 'coinDiscount']) !== undefined ? getOrderField(order, ['superCoinsDiscount', 'superCoinsAmount', 'superCoinDiscount', 'superCoinAmount', 'coinDiscount']) : getOrderField(nested, ['discount', 'discountAmount', 'amount', 'value']),
  };
};

var getGiftPackingDetails = function (order) {
  var nested = order && order.giftPacking && typeof order.giftPacking === 'object' ? order.giftPacking : {};
  var enabled = getOrderField(order, ['isGiftPacking', 'giftWrap', 'isGiftWrapped']);
  if (enabled === undefined) enabled = getOrderField(nested, ['enabled', 'isEnabled', 'selected']);
  if (enabled === undefined && order && order.giftPacking) enabled = true;
  return {
    enabled: enabled === true || enabled === 'true' || enabled === 'yes' || enabled === 'Yes',
    amount: getOrderField(order, ['giftPackingAmount', 'giftPackAmount', 'giftWrapAmount']) !== undefined ? getOrderField(order, ['giftPackingAmount', 'giftPackAmount', 'giftWrapAmount']) : getOrderField(nested, ['amount', 'price', 'cost']),
    hasValue: enabled !== undefined || Object.keys(nested).length > 0,
  };
};

var getShippingCharge = function (order) {
  return getOrderField(order, ['shippingCharge', 'shippingCharges', 'shipping_charges', 'shippingFee', 'shippingCost', 'shiprocketShippingCharge', 'deliveryCharge', 'deliveryCharges', 'deliveryFee']);
};

var getCustomerAddressText = function (customer) {
  if (!customer) return EMPTY_TEXT;
  var value = customer.address || customer.shippingAddress || customer.deliveryAddress || '';
  if (typeof value === 'string') return value.trim() || EMPTY_TEXT;
  if (!value || typeof value !== 'object') return EMPTY_TEXT;
  return [value.address || value.addressLine1 || value.line1 || value.street, value.address2 || value.addressLine2 || value.line2,
    value.city || value.town, value.state || value.province, value.pincode || value.pinCode || value.postalCode || value.zip,
    value.country, value.phone || value.mobile].filter(function (part) { return part !== undefined && part !== null && String(part).trim(); }).join(', ') || EMPTY_TEXT;
};

var getOrderCustomerEmail = function (order) {
  var entities = [order && order.user, order && order.userId, order && order.customer, order && order.customerId];
  for (var i = 0; i < entities.length; i++) {
    if (entities[i] && typeof entities[i] === 'object' && entities[i].email) return entities[i].email;
  }
  return order && (order.customerEmail || order.email || order.emailAddress) || '';
};

var displayCustomerValue = function (value) {
  return value === undefined || value === null || (typeof value === 'string' && !value.trim()) ? EMPTY_TEXT : String(value);
};

// â”€â”€ API response normalizer â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
var extractCustomerList = function (res) {
  var payload = (res && res.data) || {};
  var list = payload.data || payload.customers || payload;
  return Array.isArray(list) ? list : [];
};

var extractOrderList = function (res) {
  var payload = (res && res.data) || {};
  var list = payload.data || payload.orders || payload;
  return Array.isArray(list) ? list : [];
};

var formatCustomer = function (c, stats) {
  var s = stats || { orders: [], totalSpent: 0 };
  var orders = Array.isArray(s.orders) ? s.orders : [];
  var apiTotalSpent = Number(c.totalSpent || c.total_spent || c.total || c.amount || 0);
  var apiTotalOrders = Number(c.totalOrders || c.total_orders || c.ordersCount || c.orderCount || 0);
  var hasApiTotalSpent = Number.isFinite(apiTotalSpent) && apiTotalSpent >= 0;
  var hasApiTotalOrders = Number.isFinite(apiTotalOrders) && apiTotalOrders >= 0;
  var hasComputedOrders = Array.isArray(orders) && orders.length > 0;
  var name = getCustomerDisplayName(c);
  var orderEmail = '';
  for (var orderIndex = 0; orderIndex < orders.length; orderIndex++) {
    orderEmail = getOrderCustomerEmail(orders[orderIndex]);
    if (orderEmail) break;
  }
  return {
    _id:         getCustomerId(c),
    name: name,
    email:       c.email || c.emailAddress || (c.user && c.user.email) || (c.customer && c.customer.email) || orderEmail || EMPTY_TEXT,
    phone:       c.phone || c.mobile || c.contact || EMPTY_TEXT,
    address:     getCustomerAddressText(c),
    status:      (c.status || 'active').toLowerCase(),
    blockReason: c.blockReason || '',
    createdAt:   c.createdAt   || null,
    avatar:      c.avatar      || c.profileImage || null,
    notes:       c.notes       || '',
    orders:      orders,
    totalOrders: hasComputedOrders ? orders.length : (hasApiTotalOrders ? apiTotalOrders : 0),
    totalSpent:  hasComputedOrders ? Number(s.totalSpent || 0) : (hasApiTotalSpent ? apiTotalSpent : 0),
    isDeleted:   c.isDeleted   || false,
  };
};

var IconLock = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('rect', { x: '3', y: '11', width: '18', height: '11', rx: '2' }),
    React.createElement('path', { d: 'M7 11V7a5 5 0 0 1 10 0v4' })
  );
};

var IconUnlock = function () {
  return React.createElement('svg', { viewBox: '0 0 24 24', width: '14', height: '14', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('rect', { x: '3', y: '11', width: '18', height: '11', rx: '2' }),
    React.createElement('path', { d: 'M7 11V7a5 5 0 0 1 9.9-1' })
  );
};

var PortaledDropdown = function (props) {
  var top = props.top;
  var right = props.right;
  var onClose = props.onClose;
  var onView = props.onView;
  var onDelete = props.onDelete;
  var status = props.status;
  var onBlock = props.onBlock;
  var onUnblock = props.onUnblock;

  React.useEffect(function () {
    var handler = function (e) {
      if (!e.target.closest('.act-menu-dd-portal')) onClose();
    };
    document.addEventListener('mousedown', handler);
    return function () { document.removeEventListener('mousedown', handler); };
  }, [onClose]);

  return createPortal(
    React.createElement('div', {
      className: 'act-menu-dd-portal',
      style: {
        position: 'fixed',
        top: top,
        right: right,
        minWidth: 162,
        background: '#20105E',
        border: '1px solid rgba(62,124,140,0.28)',
        boxShadow: '0 16px 40px rgba(123,44,255,0.2), 0 4px 12px rgba(0,0,0,0.15)',
        borderRadius: 12,
        padding: 6,
        zIndex: 999999,
      }
    },
      React.createElement('button', {
        type: 'button',
        className: 'act-menu-item',
        onClick: function () { onClose(); onView(); },
        style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#C4B5FD', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', transition: 'background .12s', textAlign: 'left' }
      },
        React.createElement('span', { className: 'act-menu-icon', style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#A855F7' } }, IconView()),
        'View'
      ),
      status === 'blocked'
        ? React.createElement('button', {
            type: 'button',
            className: 'act-menu-item',
            onClick: function () { onClose(); onUnblock(); },
            style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#34d399', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', textAlign: 'left' }
          },
            React.createElement('span', { className: 'act-menu-icon', style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#34d399' } }, IconUnlock()),
            'Unblock'
          )
        : React.createElement('button', {
            type: 'button',
            className: 'act-menu-item',
            onClick: function () { onClose(); onBlock(); },
            style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#fbbf24', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', textAlign: 'left' }
          },
            React.createElement('span', { className: 'act-menu-icon', style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fbbf24' } }, IconLock()),
            'Block'
          ),
      React.createElement('button', {
        type: 'button',
        className: 'act-menu-item act-menu-delete',
        onClick: function () { onClose(); onDelete(); },
        style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#b91c1c', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', transition: 'background .12s', textAlign: 'left' }
      },
        React.createElement('span', { className: 'act-menu-icon', style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#b91c1c' } }, IconTrash()),
        'Delete'
      )
    ),
    document.body
  );
};

/* â”€â”€ Custom Select (matches theme, portaled, natural height â€” no scroll cap) â”€â”€ */
const CustomSelect = ({ value, onChange, options, disabled, triggerClassName }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
  const triggerRef = React.useRef();
  const listRef = React.useRef();

  const openList = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
    }
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return;
    const handler = (ev) => {
      if (triggerRef.current && triggerRef.current.contains(ev.target)) return;
      if (listRef.current && listRef.current.contains(ev.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    const reposition = () => {
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        setPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
      }
    };
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
    return () => {
      document.removeEventListener('mousedown', handler);
      window.removeEventListener('scroll', reposition, true);
      window.removeEventListener('resize', reposition);
    };
  }, [open]);

  const selected = options.find(o => o.value === value);

  return (
    <div style={{ position: 'relative', display: 'inline-block', width: triggerClassName === 'cust-cs-filter-trigger' ? 'auto' : '100%' }}>
      <button
        type="button"
        ref={triggerRef}
        className={'cust-cs-trigger ' + (triggerClassName || '')}
        disabled={disabled}
        onClick={() => { if (disabled) return; open ? setOpen(false) : openList(); }}
      >
        <span>{selected ? selected.label : 'Select'}</span>
        <span style={{ color: '#2d5f6e', marginLeft: 8, display: 'inline-flex' }}>{IconChevronDown()}</span>
      </button>
      {open && createPortal(
        <div
          ref={listRef}
          style={{
            position: 'fixed', top: pos.top, left: pos.left, width: pos.width,
            background: '#ffffff', border: '1px solid rgba(62,124,140,0.22)',
            borderRadius: 10, zIndex: 999999,
            boxShadow: '0 16px 40px rgba(15,23,42,0.16)',
          }}
        >
          {options.map(o => {
            const isSel = o.value === value;
            return (
              <div
                key={o.value}
                onClick={() => { onChange(o.value); setOpen(false); }}
                style={{
                  padding: '9px 12px', fontSize: 13, cursor: 'pointer',
                  color: isSel ? '#ffffff' : '#102a33',
                  background: isSel ? '#3E7C8C' : '#ffffff',
                  fontFamily: "'Sora','Outfit',sans-serif",
                  transition: 'background 0.15s',
                }}
                onMouseEnter={(ev) => { if (!isSel) ev.currentTarget.style.background = '#eef8fa'; }}
                onMouseLeave={(ev) => { if (!isSel) ev.currentTarget.style.background = '#ffffff'; }}
              >
                {o.label}
              </div>
            );
          })}
        </div>,
        document.body
      )}
    </div>
  );
};


var Customers = function () {
  var location = useLocation();
  var stateCustomers    = useState([]);
  var customers         = stateCustomers[0];
  var setCustomers      = stateCustomers[1];

  var stateLoading      = useState(true);
  var loading           = stateLoading[0];
  var setLoading        = stateLoading[1];

  var stateSearch       = useState('');
  var search            = stateSearch[0];
  var setSearch         = stateSearch[1];

  var stateSortBy       = useState('name');
  var sortBy            = stateSortBy[0];
  var setSortBy         = stateSortBy[1];

  var statePage         = useState(1);
  var currentPage       = statePage[0];
  var setCurrentPage    = statePage[1];

  var stateSelCustomer  = useState(null);
  var selCustomer       = stateSelCustomer[0];
  var setSelCustomer    = stateSelCustomer[1];

  var stateDeleteTarget = useState(null);
  var deleteTarget      = stateDeleteTarget[0];
  var setDeleteTarget   = stateDeleteTarget[1];

  var stateOpenMenuId   = useState(null);
  var openMenuId        = stateOpenMenuId[0];
  var setOpenMenuId     = stateOpenMenuId[1];

  var stateMenuPos      = useState({ top: 0, right: 0 });
  var menuPos           = stateMenuPos[0];
  var setMenuPos        = stateMenuPos[1];

  var stateActiveCard   = useState('all');
  var activeCard        = stateActiveCard[0];
  var setActiveCard     = stateActiveCard[1];

  var stateOrderRevenue = useState(0);
  var orderRevenue      = stateOrderRevenue[0];
  var setOrderRevenue   = stateOrderRevenue[1];

  var stateError        = useState('');
  var error             = stateError[0];
  var setError          = stateError[1];

  var stateDateFrom       = useState('');
  var dateFrom             = stateDateFrom[0];
  var setDateFrom          = stateDateFrom[1];

  var stateDateTo         = useState('');
  var dateTo               = stateDateTo[0];
  var setDateTo            = stateDateTo[1];

  var stateDateFilterOpen = useState(false);
  var dateFilterOpen       = stateDateFilterOpen[0];
  var setDateFilterOpen    = stateDateFilterOpen[1];

  var stateDatePreset     = useState('custom');
  var datePreset           = stateDatePreset[0];
  var setDatePreset        = stateDatePreset[1];

  var stateBlockTarget    = useState(null);
  var blockTarget          = stateBlockTarget[0];
  var setBlockTarget       = stateBlockTarget[1];

  var stateBlockReasonInput = useState('');
  var blockReasonInput       = stateBlockReasonInput[0];
  var setBlockReasonInput    = stateBlockReasonInput[1];

  var stateBlockSaving    = useState(false);
  var blockSaving          = stateBlockSaving[0];
  var setBlockSaving       = stateBlockSaving[1];

  // â”€â”€ Column sort: Customer (Aâ†”Z) / Orders (Highâ†”Low) / Spent (Highâ†”Low) â”€â”€
  var stateColumnSort     = useState(null); // { key: 'customer' | 'orders' | 'spent', dir: 'asc' | 'desc' }
  var columnSort           = stateColumnSort[0];
  var setColumnSort        = stateColumnSort[1];

  // â”€â”€ Status message for delete notifications â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var stateStatusMsg      = useState('');
  var statusMsg            = stateStatusMsg[0];
  var setStatusMsg         = stateStatusMsg[1];

  var toggleColumnSort = function (key) {
    setColumnSort(function (prev) {
      if (prev && prev.key === key) return { key: key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      var defaultDir = key === 'customer' ? 'asc' : 'desc';
      return { key: key, dir: defaultDir };
    });
  };

  // â”€â”€ Load customers + orders, then merge stats â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var loadCustomers = useCallback(function () {
    setLoading(true);
    setError('');

    Promise.allSettled([getAllCustomers(), getAllOrders()])
      .then(function (results) {
        var custRes = results[0];
        var ordRes  = results[1];

        var custList = [];
        if (custRes.status === 'fulfilled') {
          custList = extractCustomerList(custRes.value);
        } else {
          console.error('Customers fetch failed:', custRes.reason);
          setError('Failed to load customers. Check your API connection.');
        }

        custList = custList.filter(function (c) { return !c.isDeleted; });

        var orderList = [];
        if (ordRes.status === 'fulfilled') {
          orderList = extractOrderList(ordRes.value);
        } else {
          console.warn('Orders fetch failed (stats will be empty):', ordRes.reason);
        }

        orderList = orderList.filter(function (o) { return !o.isDeleted; });

        var statsMap = {};
        var getOrderStatus = function (order) {
          if (!order) return '';
          return String(order.orderStatus || order.status || order.order_status || '').toLowerCase().trim();
        };
        var revenueSum = 0;
        orderList.forEach(function (order) {
          var orderTotal = getOrderTotal(order);
          var custId = resolveOrderCustomerId(order);
          if (!custId) return;
          custId = String(custId);
          if (!statsMap[custId]) statsMap[custId] = { orders: [], totalSpent: 0 };
          statsMap[custId].orders.push(order);
          // Only include in totalSpent and revenue if not cancelled
          if (getOrderStatus(order) !== 'cancelled') {
            statsMap[custId].totalSpent += orderTotal;
            revenueSum += orderTotal;
          }
        });

        var formatted = custList.map(function (c) {
          var customerId = getCustomerId(c);
          return formatCustomer(c, statsMap[String(customerId)]);
        });

        setOrderRevenue(revenueSum);

        setCustomers(formatted);
      })
      .catch(function (err) {
        console.error('Unexpected error loading customers:', err);
        setError('An unexpected error occurred.');
        setCustomers([]);
      })
      .finally(function () {
        setLoading(false);
      });
  }, []);

  useEffect(function () { loadCustomers(); }, [loadCustomers]);

  useEffect(function () {
    var customerId = new URLSearchParams(location.search).get('customerId');
    if (!customerId || !customers.length) return;
    var match = customers.find(function (customer) { return String(customer._id || customer.id) === String(customerId); });
    if (match) setSelCustomer(match);
  }, [location.search, customers]);

  // Reset to page 1 whenever filters change
  useEffect(function () { setCurrentPage(1); }, [search, sortBy, activeCard, dateFrom, dateTo, columnSort]);

  // Close action menus on outside click
  useEffect(function () {
    var handler = function (e) {
      if (!e || !e.target || !e.target.closest) { setOpenMenuId(null); return; }
      if (e.target.closest('.act-menu-dd-portal') || e.target.closest('.act-menu-btn')) return;
      setOpenMenuId(null);
    };
    document.addEventListener('mousedown', handler);
    return function () { document.removeEventListener('mousedown', handler); };
  }, []);

  // â”€â”€ Derived stats â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var totalSpent  = customers.reduce(function (s, c) { return s + Number(c.totalSpent || 0); }, 0);
  var totalOrders = customers.reduce(function (s, c) { return s + Number(c.totalOrders || c.orders.length || 0); }, 0);
  var totalRevenue = orderRevenue;
  var avgOrders   = customers.length > 0 ? Math.round(totalOrders / customers.length) : 0;
  var topCustomer = customers.slice().sort(function (a, b) { return b.totalSpent - a.totalSpent; })[0] || null;

  // â”€â”€ Card click handler â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var handleCardClick = function (cardKey) {
    setActiveCard(cardKey);
    var sortMap = { all: 'name', active: 'name', new: 'name', inactive: 'name', blocked: 'name' };
    setSortBy(sortMap[cardKey] || 'name');
    setCurrentPage(1);
    if (cardKey === 'all') {
      setSearch('');
    }
  };

  // â”€â”€ Filter + sort pipeline â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var getFilteredAndSorted = function () {
    var list = customers.filter(function (c) {
      var q = search.toLowerCase();
      return !q
        || c.name.toLowerCase().includes(q)
        || c.email.toLowerCase().includes(q)
        || c.phone.includes(q);
    });

    if (activeCard === 'topSpender') {
      var sortedBySpend = list.slice().sort(function (a, b) { return b.totalSpent - a.totalSpent; });
      var topValue = sortedBySpend[0] ? Number(sortedBySpend[0].totalSpent || 0) : 0;
      list = list.filter(function (c) { return Number(c.totalSpent || 0) === topValue && topValue > 0; });
    } else if (activeCard === 'active' || activeCard === 'inactive' || activeCard === 'blocked') {
      list = list.filter(function (c) { return c.status === activeCard; });
    }

    if (dateFrom || dateTo) {
      list = list.filter(function (c) {
        var created = new Date(c.createdAt || 0);
        if (isNaN(created)) return false;
        if (dateFrom) {
          var start = new Date(dateFrom + 'T00:00:00');
          if (created < start) return false;
        }
        if (dateTo) {
          var end = new Date(dateTo + 'T23:59:59');
          if (created > end) return false;
        }
        return true;
      });
    }

    list = list.slice().sort(function (a, b) {
      if (sortBy === 'orders') return (Number(b.totalOrders || b.orders.length || 0) - Number(a.totalOrders || a.orders.length || 0));
      if (sortBy === 'spent')  return b.totalSpent - a.totalSpent;
      return a.name.localeCompare(b.name);
    });

    return list;
  };

  var filtered   = getFilteredAndSorted();

  // ── Apply Customer / Orders / Spent column sort on top of the filtered list ──
  var sortedFiltered = filtered.slice();
  if (columnSort) {
    var dirMul = columnSort.dir === 'asc' ? 1 : -1;
    if (columnSort.key === 'customer') {
      sortedFiltered.sort(function (a, b) { return dirMul * a.name.localeCompare(b.name); });
    } else if (columnSort.key === 'orders') {
      sortedFiltered.sort(function (a, b) {
        return dirMul * (Number(a.totalOrders || a.orders.length || 0) - Number(b.totalOrders || b.orders.length || 0));
      });
    } else if (columnSort.key === 'spent') {
      sortedFiltered.sort(function (a, b) { return dirMul * (Number(a.totalSpent || 0) - Number(b.totalSpent || 0)); });
    }
  }

  var totalPages = Math.max(1, Math.ceil(sortedFiltered.length / ITEMS_PER_PAGE));
  var safeCurrentPage = Math.min(currentPage, totalPages);
  var pageStart  = (safeCurrentPage - 1) * ITEMS_PER_PAGE;
  var pageItems  = sortedFiltered.slice(pageStart, pageStart + ITEMS_PER_PAGE);

  // ── Stat card definitions ──────────────────────────────────────────────────
  var activeCount   = customers.filter(function (c) { return c.status === 'active'; }).length;
  var inactiveCount = customers.filter(function (c) { return c.status === 'inactive'; }).length;
  var blockedCount  = customers.filter(function (c) { return c.status === 'blocked'; }).length;

  var statsData = [
    { key: 'all',      lbl: 'Total Customers',    val: customers.length, color: '#3b82f6', icon: 'users', desc: 'All customer accounts', hint: 'Show all customers' },
    { key: 'active',   lbl: 'Active Customers',   val: activeCount,      color: '#16a34a', icon: 'check', desc: 'Currently active', hint: 'Show active customers' },
    { key: 'blocked',  lbl: 'Blocked Customers',  val: blockedCount,     color: '#f97316', icon: 'lock',  desc: 'Blocked accounts', hint: 'Show blocked customers' },
    { key: 'inactive', lbl: 'Inactive Customers', val: inactiveCount,    color: '#a855f7', icon: 'pause', desc: 'Inactive accounts', hint: 'Show inactive customers' },
  ];

  // Avatar renderer ────────────────────────────────────────────────────────────
  var renderAvatar = function (c, size, colorIdx) {
    size = size || 36;
    colorIdx = colorIdx || 0;
    if (c.avatar) {
      return React.createElement('img', {
        src: c.avatar, alt: c.name,
        style: { width: size, height: size, borderRadius: '50%', objectFit: 'cover' },
      });
    }
    return React.createElement('div', {
      style: {
        width: size, height: size, borderRadius: '50%',
        background: avatarColors[colorIdx % avatarColors.length],
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: size * 0.35, fontWeight: 800, color: '#fff',
      },
    }, getInitials(c.name));
  };

  var fmtDate = function (d) {
    return d
      ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
      : EMPTY_TEXT;
  };

  var getOrderStatus = function (o) {
    return (o.orderStatus || o.status || 'pending').toLowerCase();
  };

  var statusColor = function (s) {
    var map = {
      delivered: '#34d399', processing: '#fbbf24',
      shipped: '#a855f7', cancelled: '#f87171', pending: '#ec4899',
    };
    return map[s] || '#ec4899';
  };

  var statusBadgeClass = function (status) {
    if (status === 'active') return 'bdg-g';
    if (status === 'blocked') return 'bdg-r';
    return 'bdg-b'; // inactive
  };

  // ── Delete handlers ─────────────────────────────────────────────────────────
  var handleDeleteRequest = function (customer) { setDeleteTarget(customer); };
  var handleDeleteCancel  = function () { setDeleteTarget(null); };

  var handleDeleteConfirm = function () {
    if (!deleteTarget) return;
    deleteCustomer(deleteTarget._id)
      .then(function () {
        setDeleteTarget(null);
        setCustomers(function (prev) {
          return prev.filter(function (c) { return c._id !== deleteTarget._id; });
        });
        loadCustomers();
        window.dispatchEvent(new Event('adminDataUpdated'));
        setStatusMsg('Success: Customer deleted successfully.');
        setTimeout(function () { setStatusMsg(''); }, 2500);
      })
      .catch(function (err) {
        console.error('Delete customer failed:', err);
        setDeleteTarget(null);
        setStatusMsg('Error: Delete failed. Please try again.');
        setTimeout(function () { setStatusMsg(''); }, 2500);
      });
  };

  var toggleMenu = function (id) {
    setOpenMenuId(function (prev) { return prev === id ? null : id; });
  };

  // ── Date filter helpers ─────────────────────────────────────────────────────
  var fmtDateShort = function (d) {
    return d
      ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
      : EMPTY_TEXT;
  };

  var formatDateLabel = function (from, to) {
    if (!from && !to) return 'Date range';
    if (from && !to) return fmtDateShort(from);
    if (!from && to) return fmtDateShort(to);
    return fmtDateShort(from) + ' - ' + fmtDateShort(to);
  };

  var handleDateFilterClear = function () {
    setDateFrom('');
    setDateTo('');
    setDatePreset('custom');
    setCurrentPage(1);
    setDateFilterOpen(false);
  };

  var getPresetRange = function (preset) {
    var today = new Date();
    var pad = function (v) { return String(v).padStart(2, '0'); };
    var toDateInput = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
    var result = { from: '', to: toDateInput(today) };

    if (preset === 'today') {
      result.from = result.to;
    } else if (preset === 'yesterday') {
      var y = new Date(today); y.setDate(y.getDate() - 1);
      result.from = result.to = toDateInput(y);
    } else if (preset === '7d') {
      var d7 = new Date(today); d7.setDate(d7.getDate() - 6);
      result.from = toDateInput(d7);
    } else if (preset === '30d') {
      var d30 = new Date(today); d30.setDate(d30.getDate() - 29);
      result.from = toDateInput(d30);
    } else if (preset === 'this_month') {
      var dm = new Date(today.getFullYear(), today.getMonth(), 1);
      result.from = toDateInput(dm);
    }
    return result;
  };

  var applyDatePreset = function (preset) {
    var range = getPresetRange(preset);
    setDateFrom(range.from);
    setDateTo(range.to);
    setDatePreset(preset);
    setCurrentPage(1);
  };

  // ── Export ──────────────────────────────────────────────────────────────────
  var buildExportRows = function (list) {
    var rows = [
      ['Customers Export'],
      ['Period', (dateFrom || dateTo) ? formatDateLabel(dateFrom, dateTo) : 'All time'],
      ['Filter', activeCard === 'all' ? 'All customers' : activeCard],
      ['Search', search || 'All'],
      ['Total customers', list.length],
      ['Exported at', new Date().toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })],
      [],
      ['Customer ID', 'Name', 'Email', 'Phone', 'Total Orders', 'Total Spent', 'Status', 'Joined'],
    ];
    list.forEach(function (c) {
      rows.push([
        c._id || '',
        c.name,
        c.email,
        c.phone,
        Number(c.totalOrders || c.orders.length || 0),
        Number(c.totalSpent || 0),
        c.status,
        fmtDateShort(c.createdAt),
      ]);
    });
    return rows;
  };

  var downloadExcel = function (rows, filename) {
    var workbook = new ExcelJS.Workbook();
    var sheet = workbook.addWorksheet('Customers');
    var headerRowIndex = rows.findIndex(function (r) { return r[0] === 'Customer ID'; });

    rows.forEach(function (rowData, idx) {
      var row = sheet.addRow(rowData);
      if (idx === 0) {
        row.font = { bold: true, size: 13 };
      } else if (idx === headerRowIndex) {
        row.eachCell(function (cell) {
          cell.font = { bold: true };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      } else if (idx > headerRowIndex) {
        row.eachCell(function (cell) {
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
            left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
            bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
            right: { style: 'thin', color: { argb: 'FFD9D9D9' } },
          };
        });
      } else if (idx >= 1 && idx <= 5) {
        sheet.getCell('A' + (idx + 1)).font = { bold: true };
      }
    });

    sheet.columns = [{ width: 22 }, { width: 20 }, { width: 24 }, { width: 16 }, { width: 12 }, { width: 14 }, { width: 12 }, { width: 14 }];

    workbook.xlsx.writeBuffer().then(function (buffer) {
      var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  };

  var handleExportCSV = function () {
    if (loading) { alert('Data is still loading. Please wait a moment and try again.'); return; }
    if (!filtered.length) { alert('No customers match the current filters to export.'); return; }
    downloadExcel(buildExportRows(sortedFiltered), 'customers-' + (dateFrom || 'all') + '-' + (dateTo || 'all') + '.xlsx');
  };

  // ── Block / Unblock ─────────────────────────────────────────────────────────
  var handleBlockRequest = function (customer) { setBlockTarget(customer); setBlockReasonInput(''); };
  var handleBlockCancel  = function () { if (blockSaving) return; setBlockTarget(null); setBlockReasonInput(''); };

  var handleBlockConfirm = function () {
    if (!blockTarget || !blockReasonInput.trim()) return;
    setBlockSaving(true);
    blockCustomer(blockTarget._id, blockReasonInput.trim())
      .then(function () {
        setCustomers(function (prev) {
          return prev.map(function (c) {
            return c._id === blockTarget._id ? Object.assign({}, c, { status: 'blocked', blockReason: blockReasonInput.trim() }) : c;
          });
        });
        setBlockTarget(null);
        setBlockReasonInput('');
        window.dispatchEvent(new Event('adminDataUpdated'));
        setStatusMsg('Success: Customer blocked successfully.');
        setTimeout(function () { setStatusMsg(''); }, 2500);
      })
      .catch(function (err) {
        console.error('Block customer failed:', err);
        setStatusMsg('Error: Block failed. Please try again.');
        setTimeout(function () { setStatusMsg(''); }, 2500);
      })
      .finally(function () { setBlockSaving(false); });
  };

  var handleUnblock = function (customer) {
    unblockCustomer(customer._id)
      .then(function () {
        setCustomers(function (prev) {
          return prev.map(function (c) {
            return c._id === customer._id ? Object.assign({}, c, { status: 'active', blockReason: '' }) : c;
          });
        });
        window.dispatchEvent(new Event('adminDataUpdated'));
        setStatusMsg('Success: Customer unblocked successfully.');
        setTimeout(function () { setStatusMsg(''); }, 2500);
      })
      .catch(function (err) {
        console.error('Unblock customer failed:', err);
        setStatusMsg('Error: Unblock failed. Please try again.');
        setTimeout(function () { setStatusMsg(''); }, 2500);
      });
  };

  var isSuccessMessage = statusMsg.startsWith('Success:');

  var handleMenuOpen = function (e, customerId) {
    var rect = e.currentTarget.getBoundingClientRect();
    setMenuPos({
      top: rect.bottom + 6,
      right: window.innerWidth - rect.right,
    });
    setOpenMenuId(function (prev) { return prev === customerId ? null : customerId; });
  };

  // ── CSS ─────────────────────────────────────────────────────────────────────
  var css = "\n    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');\n    .page-header-row{display:flex;align-items:flex-start;justify-content:space-between;gap:22px;margin-bottom:18px;}\n    .page-header-main{display:flex;flex-direction:column;gap:10px;max-width:calc(100% - 180px);}\n    .page-header-title-row{display:flex;align-items:center;gap:12px;}\n    .page-header-icon{display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:16px;background:rgba(123,44,255,0.15);color:var(--secondary);box-shadow:inset 0 0 0 1px rgba(123,44,255,0.25);animation:iconFloat 5s ease-in-out infinite;}\n    .page-header-icon svg{width:20px;height:20px;}\n    @keyframes iconFloat{0%,100%{transform:translateY(0);}50%{transform:translateY(-3px);}}\n    .page-title{font-size:1.6rem;font-weight:800;color:var(--text-primary);margin:0;}\n    .header-subtitle{font-size:14px;color:var(--text-secondary);font-weight:600;}\n    .ptitle{font-size:1.3rem;font-weight:800;color:var(--secondary);margin-bottom:8px;letter-spacing:-0.02em;}\n    .ptitle span{font-size:13px;font-weight:400;color:var(--text-secondary);}\n    .subtitle{font-size:13px;color:var(--text-secondary);margin-bottom:22px;}\n    .stats-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;margin-bottom:24px;}\n    @media(max-width:1100px){.stats-grid{grid-template-columns:repeat(3,1fr);}}\n    @media(max-width:650px){.stats-grid{grid-template-columns:1fr;}}\n    .stat-card{border-radius:var(--radius-lg);padding:20px 20px 16px;border:1px solid var(--border-color);background:var(--card-bg);cursor:pointer;position:relative;overflow:hidden;transition:all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);box-shadow:0 8px 24px rgba(123, 44, 255, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1);backdrop-filter:blur(10px);user-select:none;}\n    .stat-card:hover{transform:translateY(-8px) scale(1.015);box-shadow:0 16px 40px rgba(123, 44, 255, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.15);border-color:rgba(123, 44, 255, 0.3);background:var(--card-bg-hover);}\n    .stat-card.active{box-shadow:0 0 0 3px rgba(123, 44, 255, 0.1), 0 16px 40px rgba(123, 44, 255, 0.25);border-color:rgba(123, 44, 255, 0.3);background:var(--card-bg-hover);}\n    .stat-card-hint{position:absolute;top:8px;right:10px;font-size:9px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;opacity:0.55;}\n    .stat-val{font-size:1.5rem;font-weight:800;line-height:1;margin-bottom:5px;color:var(--text-primary);}\n    .stat-lbl{font-size:11px;color:var(--text-secondary);font-weight:500;}\n    .active-filter-bar{display:flex;align-items:center;gap:8px;font-size:12px;color:var(--text-secondary);margin-bottom:14px;}\n    .active-filter-tag{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;border-radius:20px;font-size:11px;font-weight:700;background:rgba(123,44,255,0.15);color:var(--secondary);}\n    .clear-filter-btn{background:none;border:none;cursor:pointer;font-size:11px;color:var(--text-secondary);text-decoration:underline;font-family:'Outfit',sans-serif;padding:0;transition:color .15s;}\n    .clear-filter-btn:hover{color:var(--primary);}\n    .error-box{padding:12px 16px;border-radius:10px;background:rgba(248,113,113,.1);border:1px solid rgba(248,113,113,.3);color:#b91c1c;font-size:13px;font-weight:600;margin-bottom:16px;}\n    .wid{background:rgba(255,255,255,0.98);border:1px solid rgba(62,124,140,0.16);border-radius:16px;padding:22px;box-shadow:0 20px 48px rgba(62,124,140,0.12);}\n    .wh{display:flex;align-items:center;justify-content:space-between;margin-bottom:18px;flex-wrap:wrap;gap:12px;}\n    .wt{font-size:14px;font-weight:700;color:#111827;}\n    .filter-bar{display:flex;align-items:center;gap:10px;flex-wrap:wrap;}\n    .filter-input{padding:9px 14px;border-radius:10px;border:1px solid #d8dee9;background:#ffffff;color:#111827;font-family:'Outfit',sans-serif;font-size:13px;outline:none;min-width:220px;}\n    .filter-input:focus{border-color:#3b82f6;box-shadow:0 0 0 3px rgba(59,130,246,0.15);}\n    .filter-select{padding:9px 14px;border-radius:10px;border:1px solid #312E81;background:#1A0B4D;color:#ffffff;font-family:'Outfit',sans-serif;font-size:13px;cursor:pointer;outline:none;}\n    .cust-cs-trigger{width:100%;text-align:left;cursor:pointer;padding:9px 12px;border-radius:10px;border:1px solid rgba(62,124,140,0.28);background:#FFFFFF;color:#102a33;font-family:'Outfit',sans-serif;font-size:13px;font-weight:700;display:flex;justify-content:space-between;align-items:center;box-sizing:border-box;box-shadow:0 1px 2px rgba(15,23,42,0.04);}\n    .cust-cs-trigger:hover{border-color:#3E7C8C;box-shadow:0 0 0 3px rgba(62,124,140,0.14);}\n    .cust-cs-trigger:disabled{opacity:.62;cursor:not-allowed;background:#f1f5f9;color:#94a3b8;}\n    .cust-cs-filter-trigger{width:auto;min-width:170px;padding:9px 14px;border-radius:10px;background:#FFFFFF;color:#102a33;}\n    .tbl{width:100%;border-collapse:collapse;}\n    .tbl th{text-align:left;font-size:10px;font-weight:700;color:#2d5f6e;text-transform:uppercase;letter-spacing:.6px;padding:0 12px 12px;border-bottom:1px solid rgba(62,124,140,0.16);background:#f8fafc;}\n    .tbl th.sortable{cursor:pointer;user-select:none;transition:color .12s;}\n    .tbl th.sortable:hover{color:#d4741a;}\n    .sort-clear-icon{margin-left:6px;cursor:pointer;opacity:.65;text-transform:none;font-weight:600;}\n    .sort-clear-icon:hover{opacity:1;color:#ec4899;}\n    .tbl td{padding:13px 12px;font-size:13px;border-bottom:1px solid rgba(129,140,248,0.12);color:#111827;vertical-align:middle;}\n    .tbl tbody tr:nth-child(odd){background:transparent;}\n    .tbl tbody tr:last-child td{border-bottom:none;}\n    .tbl tbody tr:hover{background:rgba(62,124,140,0.06);}\n    .cust-cell{display:flex;align-items:center;gap:10px;}\n    .cust-name{font-weight:700;color:#111827;font-size:13px;}\n    .cust-email{font-size:11px;color:#64748b;margin-top:1px;}\n    .cust-phone{color:#111827;font-weight:600;}\n    .bdg{display:inline-flex;align-items:center;gap:4px;font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;}\n    .bdg::before{content:'';width:5px;height:5px;border-radius:50%;background:currentColor;}\n    .bdg-g{background:rgba(16,185,129,.12);color:#059669;}\n    .bdg-b{background:rgba(251,146,60,.12);color:#f97316;}\n    .bdg-r{background:rgba(248,113,113,.12);color:#ef4444;}\n    /* ── Actions Column & Horizontal Action Buttons ── */\n    .actions-th{width:140px !important;min-width:140px !important;text-align:center !important;white-space:nowrap !important;}\n    .actions-cell{width:140px !important;min-width:140px !important;text-align:center !important;white-space:nowrap !important;padding:8px 12px !important;vertical-align:middle !important;}\n    .row-actions{display:inline-flex !important;flex-direction:row !important;align-items:center !important;justify-content:center !important;gap:8px !important;flex-wrap:nowrap !important;width:auto !important;margin:0 auto !important;}\n    .row-action-btn{width:32px !important;min-width:32px !important;max-width:32px !important;height:32px !important;min-height:32px !important;max-height:32px !important;padding:0 !important;border-radius:8px !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;flex-shrink:0 !important;cursor:pointer !important;outline:none !important;border:1px solid transparent !important;transition:all .15s ease-in-out !important;}\n    .row-action-btn svg{width:15px !important;height:15px !important;pointer-events:none !important;display:block !important;}\n    .row-action-view{background:#e0f2fe !important;border:1px solid #bae6fd !important;color:#0284c7 !important;}\n    .row-action-view:hover{background:#bae6fd !important;color:#0369a1 !important;transform:translateY(-1px) !important;box-shadow:0 2px 6px rgba(2,132,199,0.2) !important;}\n    .row-action-block{background:#fef3c7 !important;border:1px solid #fde68a !important;color:#d97706 !important;}\n    .row-action-block:hover{background:#fde68a !important;color:#b45309 !important;transform:translateY(-1px) !important;box-shadow:0 2px 6px rgba(217,119,6,0.2) !important;}\n    .row-action-unblock{background:#dcfce7 !important;border:1px solid #bbf7d0 !important;color:#16a34a !important;}\n    .row-action-unblock:hover{background:#bbf7d0 !important;color:#15803d !important;transform:translateY(-1px) !important;box-shadow:0 2px 6px rgba(22,163,74,0.2) !important;}\n    .row-action-delete{background:#fee2e2 !important;border:1px solid #fecaca !important;color:#ef4444 !important;}\n    .row-action-delete:hover{background:#fecaca !important;color:#dc2626 !important;transform:translateY(-1px) !important;box-shadow:0 2px 6px rgba(239,68,68,0.2) !important;}\n    .delete-modal-overlay{position:fixed;inset:0;background:rgba(13,6,40,0.75);backdrop-filter:blur(18px);z-index:300;display:flex;align-items:center;justify-content:center;padding:20px;}\n    .delete-modal-box{width:100%;max-width:520px;background:#20105E;border:1px solid #312E81;border-radius:24px;box-shadow:0 40px 80px rgba(109,40,217,0.25);padding:32px;color:#ffffff;}\n    .delete-modal-top{display:flex;align-items:center;justify-content:center;margin-bottom:20px;}\n    .delete-modal-icon{width:60px;height:60px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:rgba(109,40,217,0.2);color:#A855F7;font-size:1.4rem;font-weight:800;}\n    .delete-modal-title{font-size:1.6rem;font-weight:800;text-align:center;color:#ffffff;margin-bottom:8px;}\n    .delete-modal-desc{font-size:0.95rem;color:#C4B5FD;text-align:center;line-height:1.6;margin-bottom:20px;}\n    .delete-modal-target{display:flex;width:fit-content;margin:0 auto 24px;padding:12px 22px;border-radius:999px;border:1px solid rgba(168,85,247,0.3);background:rgba(109,40,217,0.15);color:#C4B5FD;font-weight:800;font-size:0.95rem;text-align:center;justify-content:center;}\n    .delete-modal-actions{display:flex;justify-content:center;gap:14px;flex-wrap:wrap;}\n    .btn-delete-confirm{padding:12px 22px;border-radius:14px;border:none;background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;font-weight:800;cursor:pointer;transition:all .18s;box-shadow:0 10px 30px rgba(109,40,217,0.3);}\n    .btn-delete-confirm:hover{background:linear-gradient(135deg,#5B21B6,#9333EA);}\n    .btn-cancel{padding:12px 22px;border-radius:14px;border:1px solid #312E81;background:transparent;color:#C4B5FD;font-weight:800;cursor:pointer;transition:all .18s;}\n    .btn-cancel:hover{background:rgba(109,40,217,0.15);}\n    .empty{text-align:center;padding:40px;color:#64748b;font-size:14px;}\n    .loading{display:flex;justify-content:center;padding:40px;}\n    .inf-spinner{width:26px;height:26px;border:3px solid rgba(109,40,217,.2);border-top-color:#A855F7;border-radius:50%;animation:spin .7s linear infinite;}\n    @keyframes spin{to{transform:rotate(360deg);}}\n    .modal-overlay{position:fixed !important;top:0;left:0;right:0;bottom:0;background:rgba(13,6,40,0.75) !important;backdrop-filter:blur(18px) !important;z-index:9999999 !important;display:flex !important;align-items:center !important;justify-content:center !important;padding:24px !important;}\n    .modal-box{background:#20105E;border:1px solid #312E81;border-radius:18px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto;padding:28px;box-shadow:0 24px 64px rgba(109,40,217,0.2);}\n    .modal-hdr{display:flex;align-items:center;justify-content:space-between;margin-bottom:22px;}\n    .modal-title{font-size:17px;font-weight:800;color:#ffffff;}\n    .modal-close{background:rgba(109,40,217,0.2);border:none;color:#C4B5FD;cursor:pointer;width:32px;height:32px;border-radius:8px;font-size:18px;display:flex;align-items:center;justify-content:center;transition:all .15s;}\n    .modal-close:hover{background:rgba(109,40,217,0.3);color:#ffffff;}\n    .profile-head{display:flex;align-items:center;gap:16px;background:#20105E;border-radius:14px;padding:18px 20px;margin-bottom:16px;border:1px solid #312E81;}\n    .profile-name{font-size:17px;font-weight:800;margin-bottom:3px;color:#ffffff;}\n    .detail-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px;}\n    .detail-full{grid-column:1/-1;}\n    .detail-item{background:#20105E;border-radius:10px;padding:13px 16px;border:1px solid #312E81;}\n    .detail-label{font-size:10px;font-weight:700;color:#C4B5FD;text-transform:uppercase;letter-spacing:.5px;margin-bottom:5px;}\n    .detail-val{font-size:14px;font-weight:600;color:#ffffff;}\n    .orders-mini-box{background:#20105E;border-radius:10px;padding:14px 16px;margin-bottom:14px;border:1px solid #312E81;}\n    .orders-mini-title{font-size:10px;font-weight:700;color:#C4B5FD;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px;}\n    .order-mini-row{display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid rgba(168,85,247,0.12);font-size:12px;gap:8px;flex-wrap:wrap;}\n    .order-mini-row:last-child{border-bottom:none;}\n    .fa{display:flex;gap:10px;margin-top:14px;justify-content:flex-end;}\n    .btn-close{padding:10px 20px;border-radius:10px;font-family:'Outfit',sans-serif;font-size:13px;font-weight:700;cursor:pointer;background:transparent;border:1px solid #312E81;color:#C4B5FD;transition:all .15s;}\n    .btn-close:hover{background:rgba(109,40,217,0.15);}\n    .filter-date-btn{display:inline-flex;align-items:center;gap:10px;padding:9px 14px;border-radius:10px;border:1px solid #312E81;background:rgba(255,255,255,0.04);color:#C4B5FD;font-size:13px;font-weight:700;cursor:pointer;transition:all .15s;white-space:nowrap;}\n    .filter-date-btn:hover{background:rgba(255,255,255,0.08);}\n    .filter-export-btn{display:inline-flex;align-items:center;gap:8px;padding:9px 14px;border-radius:10px;border:1px solid #312E81;background:rgba(109,40,217,0.18);color:#ffffff;font-size:13px;font-weight:700;cursor:pointer;transition:all .15s;white-space:nowrap;}\n    .filter-export-btn:hover{background:rgba(109,40,217,0.28);}\n    .filter-export-btn:disabled{opacity:.5;cursor:not-allowed;}\n    .date-filter-overlay{position:absolute;top:100%;right:0;width:min(420px,100%);margin-top:12px;z-index:999;}\n    .date-filter-popup{width:100%;box-sizing:border-box;border-radius:20px;background:#20105E;border:1px solid #312E81;padding:22px;box-shadow:0 24px 60px rgba(0,0,0,0.28);overflow:auto;}\n    .date-filter-popup-header{font-size:14px;font-weight:700;color:#ffffff;margin-bottom:14px;}\n    .date-filter-fields{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px;}\n    .date-filter-field{display:flex;flex-direction:column;gap:6px;}\n    .date-filter-label{font-size:11px;font-weight:700;color:#c4b5fd;text-transform:uppercase;letter-spacing:.4px;}\n    .date-filter-input{padding:12px 14px;border-radius:12px;border:1px solid #312E81;background:#15123f;color:#ffffff;font-family:'Outfit',sans-serif;font-size:13px;outline:none;}\n    .date-filter-input::-webkit-calendar-picker-indicator{filter: invert(1) brightness(2) contrast(0.8);}\n    .date-filter-presets{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:18px;}\n    .date-filter-preset-btn{padding:10px 14px;border-radius:999px;border:1px solid #312E81;background:rgba(255,255,255,0.03);color:#c4b5fd;font-size:12px;font-weight:700;cursor:pointer;transition:all .15s;}\n    .date-filter-preset-btn.is-active{background:rgba(109,40,217,0.25);border-color:#7C3AED;color:#ffffff;}\n    .date-filter-actions{display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;}\n    .date-filter-clear{padding:10px 14px;border-radius:12px;border:1px solid #312E81;background:transparent;color:#c4b5fd;cursor:pointer;}\n    .date-filter-apply{padding:10px 14px;border-radius:12px;border:none;background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;cursor:pointer;}\n    .block-reason-textarea{width:100%;box-sizing:border-box;padding:12px 14px;border-radius:12px;border:1px solid #312E81;background:#15123f;color:#ffffff;font-family:'Outfit',sans-serif;font-size:13px;outline:none;resize:vertical;margin-bottom:6px;}\n    .block-reason-hint{font-size:11px;color:#94a3b8;text-align:right;}\n  ";
  
  return React.createElement(AdminLayout, { hideLayoutOnModal: !!(selCustomer || deleteTarget) },
    React.createElement('style', null, css),
    React.createElement('style', null, ".page-header-title-row{gap:10px;}.page-header-icon{width:40px;height:40px;border-radius:14px;}.page-header-icon svg{width:18px;height:18px;}.page-title{font-size:1.45rem;}.modal-box{width:min(900px,100%) !important;max-width:900px !important;max-height:92vh !important;background:#fff !important;padding:30px !important;}.modal-title{font-size:20px !important;color:#0b1f3a !important;}.profile-head{padding:20px !important;margin-bottom:18px !important;border-left:3px solid #d99a2b !important;background:#f8fafc !important;}.profile-name{font-size:19px !important;color:#0b1f3a !important;}.detail-grid{gap:12px !important;margin-bottom:18px !important;}.detail-item{padding:15px 17px !important;border-radius:12px !important;background:#f8fafc !important;border:1px solid #dbe3ec !important;}.detail-label{font-size:10px !important;color:#2d5f6e !important;letter-spacing:.65px !important;}.detail-val{font-size:14px !important;color:#0b1f3a !important;line-height:1.5 !important;overflow-wrap:anywhere !important;}.orders-mini-title{font-size:13px !important;letter-spacing:.7px !important;color:#0b1f3a !important;padding-bottom:10px !important;border-bottom:2px solid #d99a2b !important;}.orders-mini-box>div[style*='background: #ffffff']{padding:20px !important;border-color:#dbe3ec !important;box-shadow:0 10px 24px rgba(15,23,42,.07) !important;}.fa{margin-top:22px !important;}@media(max-width:640px){.modal-box{padding:18px !important;}.profile-head{align-items:flex-start !important;}.detail-grid{grid-template-columns:1fr !important;}.detail-full{grid-column:auto !important;}.orders-mini-box>div[style*='background: #ffffff']{padding:15px !important;}}"),

    // ── Page title ────────────────────────────────────────────────────────────
    React.createElement('div', { className: 'page-header-row' },
      React.createElement('div', { className: 'page-header-main' },
        React.createElement('div', { className: 'page-header-title-row' },
          React.createElement('div', { className: 'page-header-icon' },
            React.createElement('svg', { width: '18', height: '18', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
              React.createElement('path', { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }),
              React.createElement('circle', { cx: '12', cy: '7', r: '4' })
            )
          ),
          React.createElement('div', null,
            React.createElement('h1', { className: 'page-title' }, 'Customers'),
            React.createElement('div', { className: 'header-subtitle' }, 'View all customer accounts')
          )
        )
      ),
      React.createElement('button', {
        type: 'button',
        className: 'filter-export-btn',
        disabled: loading,
        onClick: handleExportCSV,
        style: { alignSelf: 'flex-start', marginTop: 4 },
      }, loading ? 'Loading...' : React.createElement(React.Fragment, null, IconDownload(), ' Export Excel'))
    ),

    // ── Error banner ──────────────────────────────────────────────────────────
    error && React.createElement('div', { className: 'error-box' }, 'Warning: ' + error),

    // ── Status message popup ──────────────────────────────────────────────────
    statusMsg && React.createElement('div', { className: 'msg-box ' + (isSuccessMessage ? 'msg-s' : 'msg-e'), style: { marginBottom: 16, padding: '14px 18px', borderRadius: '12px', fontWeight: '600', fontSize: '14px', border: '1px solid', borderColor: (isSuccessMessage) ? '#10B981' : '#EF4444', backgroundColor: (isSuccessMessage) ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)', color: (isSuccessMessage) ? '#10B981' : '#EF4444', boxShadow: (isSuccessMessage) ? '0 4px 12px rgba(16, 185, 129, 0.3)' : '0 4px 12px rgba(239, 68, 68, 0.3)' } }, statusMsg),

    // ── Clickable stat cards ──────────────────────────────────────────────────
    React.createElement(StatCards, {
      cards: statsData.map(function (s) {
        return {
          title: s.lbl,
          value: s.val,
          description: s.desc,
          icon: s.icon,
          accent: s.color,
          active: activeCard === s.key,
          onClick: function () { handleCardClick(s.key); },
        };
      })
    }),

    activeCard !== 'all' && React.createElement('div', { className: 'active-filter-bar' },
      React.createElement('span', null, 'Filtered by:'),
      React.createElement('span', {
        className: 'active-filter-tag',
        style: {
          background: (statsData.find(function (s) { return s.key === activeCard; }) || {}).bg,
          color: (statsData.find(function (s) { return s.key === activeCard; }) || {}).color,
        },
      }, (statsData.find(function (s) { return s.key === activeCard; }) || {}).lbl),
      React.createElement('button', { className: 'clear-filter-btn', onClick: function () { handleCardClick('all'); } }, 'Clear filter')
    ),

    // ── Table widget ──────────────────────────────────────────────────────────
    React.createElement('div', { className: 'wid' },
      React.createElement('div', { className: 'wh' },
        React.createElement('span', { className: 'wt' },
          activeCard !== 'all'
            ? ((statsData.find(function (s) { return s.key === activeCard; }) || {}).lbl + ' (' + sortedFiltered.length + ')')
            : ('All Customers (' + sortedFiltered.length + ')')
        ),
        React.createElement('div', { className: 'filter-bar', style: { position: 'relative' } },
          React.createElement('input', {
            className: 'filter-input',
            placeholder: 'Search by name, email or phone...',
            value: search,
            onChange: function (e) { setSearch(e.target.value); },
          }),
          React.createElement('button', {
            type: 'button',
            className: 'filter-date-btn',
            onClick: function () { setDateFilterOpen(function (p) { return !p; }); },
          },
            React.createElement('span', { style: { display: 'inline-flex' } }, IconCalendar()),
            formatDateLabel(dateFrom, dateTo),
            (dateFrom || dateTo) && React.createElement('span', {
              style: { marginLeft: 6, cursor: 'pointer' },
              onClick: function (e) { e.stopPropagation(); handleDateFilterClear(); },
              title: 'Clear date filter',
            }, React.createElement(IconClose))
          ),
          React.createElement(CustomSelect, {
            triggerClassName: 'cust-cs-filter-trigger',
            value: sortBy,
            onChange: function (val) {
              setSortBy(val);
              if (val === 'name')  setActiveCard('all');
              if (val === 'spent') setActiveCard('topSpender');
            },
            options: [
              { value: 'name',   label: 'Sort: Name' },
              { value: 'orders', label: 'Sort: Most Orders' },
              { value: 'spent',  label: 'Sort: Most Spent' },
            ],
          }),
          dateFilterOpen && React.createElement('div', {
            className: 'date-filter-overlay',
            onClick: function () { setDateFilterOpen(false); },
          },
            React.createElement('div', { className: 'date-filter-popup', onClick: function (e) { e.stopPropagation(); } },
              React.createElement('div', { className: 'date-filter-popup-header' }, 'Filter by join date'),
              React.createElement('div', { className: 'date-filter-presets' },
                [
                  { key: 'today', label: 'Today' },
                  { key: 'yesterday', label: 'Yesterday' },
                  { key: '7d', label: 'Last 7 Days' },
                  { key: '30d', label: 'Last 30 Days' },
                  { key: 'this_month', label: 'This Month' },
                  { key: 'custom', label: 'Custom' },
                ].map(function (preset) {
                  return React.createElement('button', {
                    key: preset.key,
                    type: 'button',
                    className: 'date-filter-preset-btn' + (datePreset === preset.key ? ' is-active' : ''),
                    onClick: function () { applyDatePreset(preset.key); },
                  }, preset.label);
                })
              ),
              React.createElement('div', { className: 'date-filter-fields' },
                React.createElement('div', { className: 'date-filter-field' },
                  React.createElement('div', { className: 'date-filter-label' }, 'Start date'),
                  React.createElement('input', {
                    type: 'date', className: 'date-filter-input', value: dateFrom,
                    onChange: function (e) { setDateFrom(e.target.value); setDatePreset('custom'); },
                  })
                ),
                React.createElement('div', { className: 'date-filter-field' },
                  React.createElement('div', { className: 'date-filter-label' }, 'End date'),
                  React.createElement('input', {
                    type: 'date', className: 'date-filter-input', value: dateTo,
                    onChange: function (e) { setDateTo(e.target.value); setDatePreset('custom'); },
                  })
                )
              ),
              React.createElement('div', { className: 'date-filter-actions' },
                React.createElement('button', { type: 'button', className: 'date-filter-clear', onClick: handleDateFilterClear }, 'Clear'),
                React.createElement('button', { type: 'button', className: 'date-filter-apply', onClick: function () { setDateFilterOpen(false); setCurrentPage(1); } }, 'Apply')
              )
            )
          )
        )
      ),

      loading
        ? React.createElement('div', { className: 'loading' }, React.createElement('div', { className: 'inf-spinner' }))
        : React.createElement(React.Fragment, null,
            React.createElement('table', { className: 'tbl' },
              React.createElement('thead', null,
                React.createElement('tr', null,
                  React.createElement('th', null, '#'),
                  React.createElement('th', {
                    className: 'sortable',
                    onClick: function () { toggleColumnSort('customer'); },
                  },
                    'Customer',
                    columnSort && columnSort.key === 'customer' ? (columnSort.dir === 'asc' ? ' Asc' : ' Desc') : '',
                    columnSort && columnSort.key === 'customer' && React.createElement('span', {
                      className: 'sort-clear-icon',
                      onClick: function (e) { e.stopPropagation(); setColumnSort(null); },
                      title: 'Clear sort',
                    }, React.createElement(IconClose))
                  ),
                  React.createElement('th', null, 'Phone'),
                  React.createElement('th', {
                    className: 'sortable',
                    onClick: function () { toggleColumnSort('orders'); },
                  },
                    'Total Orders',
                    columnSort && columnSort.key === 'orders' ? (columnSort.dir === 'asc' ? ' Asc' : ' Desc') : '',
                    columnSort && columnSort.key === 'orders' && React.createElement('span', {
                      className: 'sort-clear-icon',
                      onClick: function (e) { e.stopPropagation(); setColumnSort(null); },
                      title: 'Clear sort',
                    }, React.createElement(IconClose))
                  ),
                  React.createElement('th', {
                    className: 'sortable',
                    onClick: function () { toggleColumnSort('spent'); },
                  },
                    'Total Spent',
                    columnSort && columnSort.key === 'spent' ? (columnSort.dir === 'asc' ? ' Asc' : ' Desc') : '',
                    columnSort && columnSort.key === 'spent' && React.createElement('span', {
                      className: 'sort-clear-icon',
                      onClick: function (e) { e.stopPropagation(); setColumnSort(null); },
                      title: 'Clear sort',
                    }, React.createElement(IconClose))
                  ),
                  React.createElement('th', null, 'Status'),
                  React.createElement('th', { className: 'actions-th' }, 'Actions')
                )
              ),
              React.createElement('tbody', null,
                pageItems.length === 0
                  ? React.createElement('tr', null, React.createElement('td', { colSpan: 7, className: 'empty' }, 'No customers found.'))
                  : pageItems.map(function (c, idx) {
                      return React.createElement('tr', { key: c._id },
                        React.createElement('td', { style: { color: '#111827', fontSize: 13, fontWeight: 500 } }, pageStart + idx + 1),
                        React.createElement('td', null,
                          React.createElement('div', { className: 'cust-cell' },
                            renderAvatar(c, 36, pageStart + idx),
                            React.createElement('div', null,
                              React.createElement('div', { className: 'cust-name' }, c.name),
                              React.createElement('div', { className: 'cust-email' }, c.phone !== EMPTY_TEXT ? c.phone : c.email)
                            )
                          )
                        ),
                        React.createElement('td', { className: 'cust-phone', style: { color: '#111827', fontSize: 13, fontWeight: 500 } }, c.phone),
                        React.createElement('td', null,
                          React.createElement('span', { style: { color: '#ec4899', fontWeight: 700 } }, Number.isFinite(Number(c.totalOrders)) ? Number(c.totalOrders) : c.orders.length)
                        ),
                        React.createElement('td', { style: { color: '#111827', fontWeight: 600 } },
                          INR + Number(c.totalSpent || 0).toLocaleString('en-IN')
                        ),
                        React.createElement('td', null,
                          React.createElement('span', {
                            className: 'bdg ' + statusBadgeClass(c.status),
                          }, c.status === 'active' ? 'Active' : c.status === 'blocked' ? 'Blocked' : 'Inactive')
                        ),
                        React.createElement('td', { className: 'actions-cell' },
                          React.createElement('div', { className: 'row-actions' },
                            React.createElement('button', {
                              type: 'button',
                              className: 'row-action-btn row-action-view',
                              title: 'View Details',
                              'aria-label': 'View Details',
                              onClick: function (e) { e.stopPropagation(); setSelCustomer(c); }
                            }, React.createElement(IconView)),
                            c.status === 'blocked'
                              ? React.createElement('button', {
                                  type: 'button',
                                  className: 'row-action-btn row-action-unblock',
                                  title: 'Unblock Customer',
                                  'aria-label': 'Unblock Customer',
                                  onClick: function (e) { e.stopPropagation(); handleUnblock(c); }
                                }, React.createElement(IconUnlock))
                              : React.createElement('button', {
                                  type: 'button',
                                  className: 'row-action-btn row-action-block',
                                  title: 'Block Customer',
                                  'aria-label': 'Block Customer',
                                  onClick: function (e) { e.stopPropagation(); handleBlockRequest(c); }
                                }, React.createElement(IconLock)),
                            React.createElement('button', {
                              type: 'button',
                              className: 'row-action-btn row-action-delete',
                              title: 'Delete Customer',
                              'aria-label': 'Delete Customer',
                              onClick: function (e) { e.stopPropagation(); handleDeleteRequest(c); }
                            }, React.createElement(IconTrash))
                          )
                        )
                      );
                    })
              )
            ),
            React.createElement(Pagination, {
              currentPage: safeCurrentPage,
              totalPages: totalPages,
              onPageChange: setCurrentPage,
              totalItems: sortedFiltered.length,
            })
          )
    ),

    // â”€â”€ Delete confirmation modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    deleteTarget && React.createElement('div', {
      className: 'delete-modal-overlay',
      onClick: function (e) { if (e.target.classList.contains('delete-modal-overlay')) handleDeleteCancel(); },
    },
      React.createElement('div', { className: 'delete-modal-box' },
        React.createElement('div', { className: 'delete-modal-top' },
          React.createElement('div', { className: 'delete-modal-icon' }, '!')
        ),
        React.createElement('div', { className: 'delete-modal-title' }, 'Confirm delete?'),
        React.createElement('div', { className: 'delete-modal-desc' }, 'This action cannot be undone.'),
        React.createElement('div', { className: 'delete-modal-target' }, deleteTarget.name),
        React.createElement('div', { className: 'delete-modal-actions' },
          React.createElement('button', { className: 'btn-cancel', onClick: handleDeleteCancel }, 'Cancel'),
          React.createElement('button', { className: 'btn-delete-confirm', onClick: handleDeleteConfirm }, 'Delete')
        )
      )
    ),

    // â”€â”€ Block reason modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    blockTarget && React.createElement('div', {
      className: 'delete-modal-overlay',
      onClick: function (e) { if (e.target.classList.contains('delete-modal-overlay')) handleBlockCancel(); },
    },
      React.createElement('div', { className: 'delete-modal-box' },
        React.createElement('div', { className: 'delete-modal-top' },
          React.createElement('div', { className: 'delete-modal-icon' }, React.createElement(IconLock))
        ),
        React.createElement('div', { className: 'delete-modal-title' }, 'Block customer?'),
        React.createElement('div', { className: 'delete-modal-desc' }, 'They will be logged out immediately and blocked from logging back in until unblocked.'),
        React.createElement('div', { className: 'delete-modal-target' }, blockTarget.name),
        React.createElement('textarea', {
          className: 'block-reason-textarea',
          rows: 3,
          maxLength: 300,
          placeholder: 'Reason the customer will see (required)...',
          value: blockReasonInput,
          onChange: function (e) { setBlockReasonInput(e.target.value); },
        }),
        React.createElement('div', { className: 'block-reason-hint' }, blockReasonInput.length + '/300'),
        React.createElement('div', { className: 'delete-modal-actions', style: { marginTop: 14 } },
          React.createElement('button', { className: 'btn-cancel', onClick: handleBlockCancel, disabled: blockSaving }, 'Cancel'),
          React.createElement('button', {
            className: 'btn-delete-confirm',
            onClick: handleBlockConfirm,
            disabled: blockSaving || !blockReasonInput.trim(),
            style: (blockSaving || !blockReasonInput.trim()) ? { opacity: 0.5, cursor: 'not-allowed' } : undefined,
          }, blockSaving ? 'Blocking...' : 'Block Customer')
        )
      )
    ),

    // â”€â”€ View / profile modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    selCustomer && React.createElement('div', {
      className: 'modal-overlay',
      onClick: function (e) { if (e.target.classList.contains('modal-overlay')) setSelCustomer(null); },
    },
      React.createElement('div', { className: 'modal-box', style: { width: 'min(900px, 100%)', maxHeight: '92vh', overflowY: 'auto' } },
        React.createElement('div', { className: 'modal-hdr' },
          React.createElement('span', { className: 'modal-title', style: { display: 'inline-flex', alignItems: 'center', gap: 8 } }, IconUser(), 'Customer Profile'),
          React.createElement('button', { className: 'modal-close', onClick: function () { setSelCustomer(null); }, title: 'Close' }, React.createElement(IconClose))
        ),

        React.createElement('div', { className: 'profile-head' },
          React.createElement('div', {
            style: {
              width: 56, height: 56, borderRadius: '50%',
              background: selCustomer.avatar ? 'transparent' : avatarColors[0],
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 20, fontWeight: 800, color: '#fff', flexShrink: 0, overflow: 'hidden',
            },
          },
            selCustomer.avatar
              ? React.createElement('img', {
                  src: selCustomer.avatar, alt: selCustomer.name,
                  style: { width: 56, height: 56, borderRadius: '50%', objectFit: 'cover' },
                })
              : getInitials(selCustomer.name)
          ),
          React.createElement('div', null,
            React.createElement('div', { className: 'profile-name' }, selCustomer.name),
            React.createElement('div', { style: { color: '#2d5f6e', fontSize: 13, fontWeight: 600 } }, displayCustomerValue(selCustomer.email))
          ),
          React.createElement('span', {
            className: 'bdg ' + statusBadgeClass(selCustomer.status),
            style: { marginLeft: 'auto' },
          }, selCustomer.status)
        ),

        React.createElement('div', { className: 'detail-grid' },
          React.createElement('div', { className: 'detail-item' },
            React.createElement('div', { className: 'detail-label' }, 'Total Orders'),
            React.createElement('div', { className: 'detail-val', style: { color: '#ec4899' } }, Number(selCustomer.totalOrders || selCustomer.orders.length || 0))
          ),
          React.createElement('div', { className: 'detail-item' },
            React.createElement('div', { className: 'detail-label' }, 'Total Spent'),
            React.createElement('div', { className: 'detail-val', style: { color: '#34d399' } },
              INR + selCustomer.totalSpent.toLocaleString('en-IN')
            )
          ),
          React.createElement('div', { className: 'detail-item' },
            React.createElement('div', { className: 'detail-label' }, 'Phone'),
            React.createElement('div', { className: 'detail-val' }, displayCustomerValue(selCustomer.phone))
          ),
          React.createElement('div', { className: 'detail-item' },
            React.createElement('div', { className: 'detail-label' }, 'Email'),
            React.createElement('div', { className: 'detail-val' }, displayCustomerValue(selCustomer.email))
          ),
          React.createElement('div', { className: 'detail-item' },
            React.createElement('div', { className: 'detail-label' }, 'Avg Order Value'),
            React.createElement('div', { className: 'detail-val', style: { color: '#fbbf24' } },
              INR + ((Number(selCustomer.totalOrders || selCustomer.orders.length || 0) > 0)
                ? Math.round(selCustomer.totalSpent / Number(selCustomer.totalOrders || selCustomer.orders.length || 0)).toLocaleString('en-IN')
                : 0)
            )
          ),
          React.createElement('div', { className: 'detail-item detail-full' },
            React.createElement('div', { className: 'detail-label' }, 'Customer ID'),
            React.createElement('div', { className: 'detail-val', style: { fontSize: 11, color: '#ffffff' } },
              displayCustomerValue(selCustomer._id ? '#' + selCustomer._id.slice(-8).toUpperCase() : undefined)
            )
          ),
          React.createElement('div', { className: 'detail-item detail-full' },
            React.createElement('div', { className: 'detail-label' }, 'Address'),
            React.createElement('div', { className: 'detail-val', style: { fontSize: 13, color: '#ffffff' } },
              displayCustomerValue(selCustomer.address)
            )
          ),
          selCustomer.status === 'blocked' && React.createElement('div', { className: 'detail-item detail-full' },
            React.createElement('div', { className: 'detail-label' }, 'Block Reason'),
            React.createElement('div', { className: 'detail-val', style: { fontSize: 13, color: '#fca5a5' } },
              selCustomer.blockReason || EMPTY_TEXT
            )
          )
        ),

        React.createElement('div', { className: 'orders-mini-box', style: { marginTop: 18, padding: 0, background: 'transparent', border: 'none', boxShadow: 'none' } },
          React.createElement('div', { className: 'orders-mini-title', style: { marginBottom: 12 } },
            'Purchase History / Products Purchased (' + selCustomer.orders.length + ')'
          ),
          selCustomer.orders.length === 0
            ? React.createElement('div', { style: { padding: '18px 0', color: '#64748b', fontSize: 13, textAlign: 'center' } }, 'No purchase history available.')
            : selCustomer.orders
                .slice()
                .sort(function (a, b) { return new Date(b.createdAt || 0) - new Date(a.createdAt || 0); })
                .map(function (o, i) {
                  var st = getOrderStatus(o) || 'pending';
                  var paymentStatus = String(o.paymentStatus || o.payment_status || 'pending').trim();
                  var paymentMethod = String(o.paymentMethod || o.payment_method || 'COD').trim();
                  var couponCode = getOrderCouponCode(o);
                  var couponMeta = getOrderCouponMeta(o);
                  var couponDiscountValue = getOrderCouponDiscountValue(o);
                  var discount = getOrderDiscount(o);
                  var items = getOrderItems(o);
                  var subtotalField = getOrderField(o, ['subtotal', 'subTotal', 'subtotalAmount']);
                  var subtotal = Number(subtotalField !== undefined ? subtotalField : getOrderSubtotal(o)) || 0;
                  var giftPacking = getGiftPackingDetails(o);
                  var superCoins = getSuperCoinDetails(o);
                  var shippingCharge = getShippingCharge(o);
                  var otherDiscount = getOrderField(o, ['otherDiscount', 'otherDiscountAmount', 'discountAmount', 'discount', 'totalDiscount']);
                  return React.createElement('div', { key: o._id || i, style: { background: '#ffffff', border: '1px solid #d8dee9', borderRadius: 12, padding: 16, marginBottom: 12, boxShadow: '0 6px 18px rgba(15,23,42,.05)' } },
                    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap', paddingBottom: 12, borderBottom: '1px solid #e5e7eb' } },
                      React.createElement('div', null,
                        React.createElement('div', { style: { color: '#0b1f3a', fontSize: 13, fontWeight: 800, fontFamily: 'monospace' } }, '#' + (o._id || '').slice(-8).toUpperCase()),
                        React.createElement('div', { style: { color: '#64748b', fontSize: 11, marginTop: 4 } }, 'Date: ' + fmtDateShort(o.createdAt))
                      ),
                      React.createElement('div', { style: { display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' } },
                        React.createElement('span', { className: 'bdg ' + statusBadgeClass(st) }, st),
                        React.createElement('span', { className: 'bdg', style: { background: '#ecfdf5', color: '#047857', border: '1px solid #a7f3d0' } }, paymentStatus)
                      )
                    ),
                    React.createElement('div', { style: { display: 'flex', gap: 16, flexWrap: 'wrap', padding: '10px 0', color: '#64748b', fontSize: 11 } },
                      React.createElement('span', null, 'Payment: ', React.createElement('strong', { style: { color: '#0f172a' } }, paymentStatus + ' / ' + paymentMethod.toUpperCase())),
                      React.createElement('span', null, 'Products: ', React.createElement('strong', { style: { color: '#0f172a' } }, items.length))
                    ),
                    React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
                      items.length === 0
                        ? React.createElement('div', { style: { color: '#64748b', fontSize: 12, padding: '8px 0' } }, 'No product details available.')
                        : items.map(function (item, itemIndex) {
                            var product = getProductData(item);
                            var name = product.name || product.productName || product.title || item.name || item.productName || item.title || ('Product ' + (itemIndex + 1));
                            var quantity = Number(item.quantity !== undefined ? item.quantity : (item.qty || 1)) || 1;
                            var unitPrice = Number(product.price !== undefined ? product.price : (item.price !== undefined ? item.price : (item.unitPrice !== undefined ? item.unitPrice : (item.totalPrice !== undefined ? item.totalPrice : item.total)))) || 0;
                            var variant = getProductVariant(item);
                            var image = getProductImage(item);
                            return React.createElement('div', { key: item._id || itemIndex, style: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: itemIndex < items.length - 1 ? '1px solid #f1f5f9' : 'none' } },
                              image
                                ? React.createElement('img', { src: image, alt: name, style: { width: 46, height: 46, objectFit: 'cover', borderRadius: 8, border: '1px solid #d8dee9', flexShrink: 0 } })
                                : React.createElement('div', { style: { width: 46, height: 46, borderRadius: 8, border: '1px solid #cfe7ff', background: '#eef6ff', color: '#0b4b77', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 800, flexShrink: 0 } }, 'Box'),
                              React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                                React.createElement('div', { style: { color: '#0f172a', fontSize: 12, fontWeight: 800, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, name),
                                React.createElement('div', { style: { color: '#64748b', fontSize: 11, marginTop: 3 } }, (variant ? 'Variant / Size: ' + variant + '  ' : '') + 'Qty: ' + quantity + '  |  Unit Price: ' + INR + unitPrice.toLocaleString('en-IN'))
                              ),
                              React.createElement('div', { style: { color: '#d99a2b', fontSize: 12, fontWeight: 800, whiteSpace: 'nowrap' } }, 'Total: ' + INR + (unitPrice * quantity).toLocaleString('en-IN'))
                            );
                          })
                    ),
                    React.createElement('div', { style: { borderTop: '1px solid #e5e7eb', marginTop: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12 } },
                      React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'Subtotal'), React.createElement('strong', { style: { color: '#0f172a' } }, INR + subtotal.toLocaleString('en-IN'))),
                      giftPacking.hasValue && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'Gift Packing (' + (giftPacking.enabled ? 'Yes' : 'No') + ')'), React.createElement('strong', { style: { color: giftPacking.enabled ? '#b7791f' : '#64748b' } }, giftPacking.amount !== undefined ? INR + Number(giftPacking.amount).toLocaleString('en-IN') : 'Selected')),
                      (superCoins.used !== undefined || superCoins.amount !== undefined) && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'ISHMAI Coins Used'), React.createElement('strong', { style: { color: '#0f172a' } }, superCoins.used !== undefined ? displayCustomerValue(superCoins.used) : '—')),
                      superCoins.amount !== undefined && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'ISHMAI Coins Discount Amount'), React.createElement('strong', { style: { color: '#059669' } }, '-' + INR + Number(superCoins.amount).toLocaleString('en-IN'))),
                      shippingCharge !== undefined && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'Shipping Charge'), React.createElement('strong', { style: { color: '#0f172a' } }, INR + Number(shippingCharge).toLocaleString('en-IN'))),
                      couponCode && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#64748b' } }, React.createElement('span', null, 'Coupon Used'), React.createElement('span', { style: { padding: '3px 8px', borderRadius: 6, background: '#fff7e6', border: '1px solid rgba(217,154,43,.35)', color: '#b7791f', fontSize: 10, fontWeight: 800 } }, couponCode)),
                      (couponMeta.type !== undefined || couponMeta.value !== undefined) && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'Coupon Discount Type / Value'), React.createElement('strong', { style: { color: '#0f172a' } }, String(couponMeta.type || 'Value') + (couponMeta.value !== undefined ? ' / ' + couponMeta.value + (String(couponMeta.type || '').toLowerCase().includes('percent') ? '%' : '') : ''))),
                      couponDiscountValue !== undefined && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'Coupon Discount Amount'), React.createElement('strong', { style: { color: '#059669' } }, '-' + INR + Number(couponDiscountValue).toLocaleString('en-IN'))),
                      otherDiscount !== undefined && React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', color: '#64748b' } }, React.createElement('span', null, 'Other Discount'), React.createElement('strong', { style: { color: '#059669' } }, '-' + INR + Number(otherDiscount).toLocaleString('en-IN'))),
                      React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #e5e7eb', marginTop: 3, paddingTop: 8, color: '#0f172a', fontWeight: 800 } }, React.createElement('span', null, 'Final Total'), React.createElement('span', { style: { color: '#d99a2b', fontSize: 14 } }, INR + getOrderTotal(o).toLocaleString('en-IN')))
                    )
                  );
                })
        ),

        React.createElement('div', { className: 'fa' },
          React.createElement('button', { className: 'btn-close', onClick: function () { setSelCustomer(null); } }, 'Close')
        )
      )
    )
  );
};

export default Customers;





